import { message, Modal } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";

import useAppDispatch from "../../../../redux/hooks/useAppDispatch";
import { useEventsSchedules } from "./useEventsSchedule";
import {
  deleteEventSchedule,
  eventScheduleChangeModalState,
  refreshTableEventSchedule,
  setEventScheduleForUpdate,
  setIsEventScheduleForUpdate,
} from "../../../../redux";

const { confirm } = Modal;

export const useTableEventsSchedules = () => {
  const dispatch = useAppDispatch();
  const { tableProps } = useEventsSchedules();

  const changeEventScheduleForUpdate = (item: any) => {
    dispatch(setIsEventScheduleForUpdate(true));
    dispatch(setEventScheduleForUpdate(item));
    dispatch(eventScheduleChangeModalState());
  };

  const showDeleteConfirm = (valId: number, val: string) => {
    confirm({
      title: `Estás seguro de borrar el programa académico con el id: ${valId}`,
      icon: <ExclamationCircleOutlined />,
      content: `Una vez ejecutada esta acción no hay vuelta atrás, estás por borrar a "${val}", si deseas continuar dale click a "Borrar programa académico" en caso tal no quieras, solo oprime en "Cancelar".`,
      okText: "Borrar programa académico",
      okType: "danger",
      cancelText: "Cancelar",
      keyboard: true,
      maskClosable: true,
      async onOk() {
        await deleteEventSchedule(valId)
          .then(() => {
            dispatch(refreshTableEventSchedule(true));
            message.success(`Se ha borrado el programa académico con id:${valId}`);
            tableProps?.refresh();
          })
          .catch((err) => {
            console.log({ err });
            message.error(err.message);
          });
      },
      onCancel() {},
    });
  };
  return {
    //state
    //methods
    //functions
    changeEventScheduleForUpdate,
    showDeleteConfirm,
  };
};
